/**
 * Configuration interface
 *
 * @interface Configuration
 */
interface Configuration {
  apiUrl: string;
  appUrl: string;
  auth: {
    clientId: string;
    teamId: string;
    scopes: string;
    callbackUrl: string;
  };
  disableAuth: boolean;
}
const appUrl = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ''
}`;

export default {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:4000/',
  appUrl,
  auth: {
    clientId: '2172920488.1182972851008',
    teamId: 'T0252T2EC',
    scopes: 'identity.basic,identity.team,identity.email',
    callbackUrl: `${appUrl}/callback`,
  },
  disableAuth: Boolean(process.env.REACT_APP_DISABLE_AUTH) || false,
} as Configuration;
